interface WizardHelperFunctions {
  calculateYearsActive: (startDate: string | Date) => number;
  isFirstYear: (startDate: string | Date) => boolean;
  isProfessionalCasse: (regime: string) => boolean;
  isInpsCasse: (regime: string) => boolean;
}

export function calculateYearsActive(startDate: string | Date): number {
  if (!startDate) return 0;
  const parsedStartDate = startDate instanceof Date ? startDate : new Date(startDate);
  const today = new Date();
  let years = today.getFullYear() - parsedStartDate.getFullYear();
  const m = today.getMonth() - parsedStartDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < parsedStartDate.getDate())) {
    years--;
  }
  return years;
}

export function isFirstYear(startDate: string | Date): boolean {
  if (!startDate) return true; // If no start date, assume it's the first year
  const parsedStartDate = startDate instanceof Date ? startDate : new Date(startDate);
  const currentYear = new Date().getFullYear();
  return parsedStartDate.getFullYear() === currentYear;
}

export function isProfessionalCasse(regime: string): boolean {
  if (!regime) return false;
  const professionalCasse = [
    'CASSA_FORENSE',
    'INARCASSA_ARCHITETTI',
    'INARCASSA_GEOMETRI',
    'CIPAG_GEOMETRI',
    'INARCASSA_INGEGNERI',
  ];
  return professionalCasse.includes(regime);
}

export function isInpsCasse(regime: string): boolean {
  if (!regime) return false;
  const inpsCasse = [
    'IVS_ARTIGIANI',
    'IVS_COMMERCIANTI',
    'GESTIONE_SEPARATA',
    'GESTIONE_SEPARATA_EX_INPGI',
    'IVS_COMMERCIANTI_ENASARCO',
  ];
  return inpsCasse.includes(regime);
}

export function evaluateCondition(
  conditionString: string,
  formData: Record<string, any>,
  helperFunctions: WizardHelperFunctions
): boolean {
  try {
    const args = ['formData', ...Object.keys(helperFunctions)];
    const funcBody = `return ${conditionString};`;
    const conditionFunction = new Function(...args, funcBody);

    const values = [formData, ...Object.values(helperFunctions)];
    return conditionFunction(...values);
  } catch (e) {
    console.error("Error evaluating condition:", conditionString, e);
    return false;
  }
}

export function getProcessedLabel(label: string): string {
  if (!label) return '';
  const currentYear = new Date().getFullYear();
  return label.replace('{CURRENT_YEAR-1}', String(currentYear - 1));
}